import React, { FC, useState, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router';
import { useStyles } from './styles';
import { Grid } from '@material-ui/core';
const Callback: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const {
    userStore: { googleAuth },
    notificationStore: { openNotification },
  } = useStore();
  const [message, setMessage] = useState('');

  const googleRequest = useMutation(() => googleAuth(location.search, 'user'), {
    onSuccess: (data: any) => {
      if (data.data?.status === 'User not found' || data.data?.redirect === 'register') {
        const status = 'notFound';
        localStorage.setItem('status', status);
        localStorage.setItem('googleRegister', JSON.stringify(data.data.user));
        const Loginmessage = `Your account doesn't exist`;
        setMessage(Loginmessage);
        setTimeout(() => {
          const protocol = window.location.protocol;
          const hostname = window.location.hostname;
          const port = window.location.port;
          const urlParams = new URLSearchParams(location.search);
          const domain = urlParams.get('domain') || urlParams.get('state');

          if (domain) {
            const isLocalhost = hostname.includes('localhost');
            let baseHost;
            if (isLocalhost) {
              baseHost = `localhost${port ? ':' + port : ''}`;
            } else {
              const parts = hostname.split('.');
              baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
            }
            window.location.href = `${protocol}//${domain}.${baseHost}/login`;
          } else {
            history.push('/login');
          }
        }, 2000);
      } else if (data.data?.status === 'Client not found') {
        const Loginmessage = 'You are not authorized to log in.';
        setMessage(Loginmessage);
      } else if (
        data.data.user.permission === 'EndUser' ||
        data.data.user.role === 'end_user' ||
        data.data.user.permission === 'Manager' ||
        data.data.user.role === 'manager'
      ) {
        const token = data.data.token;
        const hostName = data.data?.domain || data.domain;
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port;
        const userData = JSON.stringify(data.data?.user);
        const orgName = data.data?.organizationName;
        const authToken = token?.replace('Bearer ', '') || localStorage.getItem('token')?.replace('Bearer ', '');

        if (hostName && !hostname.startsWith(`${hostName}.`)) {
          const isLocalhost = hostname.includes('localhost');
          let baseHost;
          if (isLocalhost) {
            baseHost = `localhost${port ? ':' + port : ''}`;
          } else {
            const parts = hostname.split('.');
            baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
          }
          window.location.href = `${protocol}//${hostName}.${baseHost}/users?token=${authToken}&userData=${encodeURIComponent(
            userData
          )}&orgName=${encodeURIComponent(orgName || '')}`;
        } else {
          history.push(handleCompanyUrl('/login'));
        }
      } else if (data.data.user.permission !== 'EndUser') {
        // Handle Admin/other permissions
        const token = data.data.token;
        const hostName = data.data?.domain || data.domain;
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port;
        const userData = JSON.stringify(data.data?.user);
        const orgName = data.data?.organizationName;
        const authToken = token?.replace('Bearer ', '') || localStorage.getItem('token')?.replace('Bearer ', '');

        if (hostName && !hostname.startsWith(`${hostName}.`)) {
          const isLocalhost = hostname.includes('localhost');
          let baseHost;
          if (isLocalhost) {
            baseHost = `localhost${port ? ':' + port : ''}`;
          } else {
            const parts = hostname.split('.');
            baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
          }
          window.location.href = `${protocol}//${hostName}.${baseHost}/dashboard?token=${authToken}&userData=${encodeURIComponent(
            userData
          )}&orgName=${encodeURIComponent(orgName || '')}`;
        } else {
          history.push(handleCompanyUrl('/reports'));
        }
      }
    },
    onError: ({ message }: Error) => {
      openNotification('error', message ? message : 'Something went wrong');
      setTimeout(() => {
        // Check if we have domain info for redirect
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port;
        const urlParams = new URLSearchParams(location.search);
        const domain = urlParams.get('domain') || urlParams.get('state');

        if (domain) {
          const isLocalhost = hostname.includes('localhost');
          let baseHost;
          if (isLocalhost) {
            baseHost = `localhost${port ? ':' + port : ''}`;
          } else {
            const parts = hostname.split('.');
            baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
          }
          window.location.href = `${protocol}//${domain}.${baseHost}/login`;
        } else {
          history.push('/login');
        }
      }, 2000); // 3 seconds se 2 seconds kar diya
    },
  });

  useEffect(() => {
    if (location.search) {
      new URLSearchParams(location.search);
      googleRequest.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useAppPreloader(googleRequest.isLoading);

  return (
    <>
      {message && (
        <div className={classes.containers}>
          <div className={classes.alertContainer}>
            <div className={classes.alertboxes}>
              <Grid className={classes.alertmessage}>
                <div className={classes.alertbox}>
                  <div>
                    <div className={classes.alertTitle}>{message}</div>
                  </div>
                </div>
              </Grid>
            </div>
          </div>
        </div>
      )}
    </>
  );
});
export default Callback;
